import { KoAPI } from 'packages';

const BASE = '/v1/monitoring';
const ALERTS_BASE = '/v1/alerts';
const INCIDENTS_BASE = '/v1/incidents';

export const MonitoringAPI = {
  // ── Service Health ────────────────────────────────────────────
  getServiceHealth: (params) =>
    KoAPI.get(`${BASE}/services`, { params }),

  getServiceHealthById: (serviceId) =>
    KoAPI.get(`${BASE}/services/${serviceId}`),

  // ── Live Metrics ──────────────────────────────────────────────
  getLiveMetrics: (serviceId, params) =>
    KoAPI.get(`${BASE}/services/${serviceId}/metrics`, { params }),

  getMetricsSummary: (params) =>
    KoAPI.get(`${BASE}/metrics/summary`, { params }),

  // ── Release Monitoring ────────────────────────────────────────
  getReleaseMonitoring: (releaseId) =>
    KoAPI.get(`${BASE}/releases/${releaseId}`),

  getReleaseComparison: (releaseId, params) =>
    KoAPI.get(`${BASE}/releases/${releaseId}/comparison`, { params }),

  getMonitoringWindow: (releaseId) =>
    KoAPI.get(`${BASE}/releases/${releaseId}/window`),

  markWindowPassed: (releaseId) =>
    KoAPI.post(`${BASE}/releases/${releaseId}/window/pass`),

  extendWindow: (releaseId, data) =>
    KoAPI.post(`${BASE}/releases/${releaseId}/window/extend`, data),

  triggerRollback: (releaseId, data) =>
    KoAPI.post(`${BASE}/releases/${releaseId}/rollback`, data),

  // ── Logs ──────────────────────────────────────────────────────
  searchLogs: (params) =>
    KoAPI.get(`${BASE}/logs`, { params }),

  getLogById: (logId) =>
    KoAPI.get(`${BASE}/logs/${logId}`),

  // ── Alerts ────────────────────────────────────────────────────
  getAlertRules: (params) =>
    KoAPI.get(ALERTS_BASE, { params }),

  getAlertRuleById: (alertId) =>
    KoAPI.get(`${ALERTS_BASE}/${alertId}`),

  createAlertRule: (data, alertId) =>
    alertId
      ? KoAPI.put(`${ALERTS_BASE}/${alertId}`, data)
      : KoAPI.post(ALERTS_BASE, data),

  deleteAlertRule: (alertId) =>
    KoAPI.delete(`${ALERTS_BASE}/${alertId}`),

  toggleAlertRule: (alertId, data) =>
    KoAPI.put(`${ALERTS_BASE}/${alertId}/toggle`, data),

  getAlertHistory: (params) =>
    KoAPI.get(`${ALERTS_BASE}/history`, { params }),

  acknowledgeAlert: (alertId) =>
    KoAPI.post(`${ALERTS_BASE}/${alertId}/acknowledge`),

  resolveAlert: (alertId) =>
    KoAPI.post(`${ALERTS_BASE}/${alertId}/resolve`),

  silenceAlert: (alertId, data) =>
    KoAPI.post(`${ALERTS_BASE}/${alertId}/silence`, data),

  // ── Alert Channels ────────────────────────────────────────────
  getAlertChannels: (params) =>
    KoAPI.get(`${ALERTS_BASE}/channels`, { params }),

  createAlertChannel: (data, channelId) =>
    channelId
      ? KoAPI.put(`${ALERTS_BASE}/channels/${channelId}`, data)
      : KoAPI.post(`${ALERTS_BASE}/channels`, data),

  deleteAlertChannel: (channelId) =>
    KoAPI.delete(`${ALERTS_BASE}/channels/${channelId}`),

  testAlertChannel: (channelId) =>
    KoAPI.post(`${ALERTS_BASE}/channels/${channelId}/test`),

  // ── Incidents ─────────────────────────────────────────────────
  getIncidents: (params) =>
    KoAPI.get(INCIDENTS_BASE, { params }),

  getIncidentById: (incidentId) =>
    KoAPI.get(`${INCIDENTS_BASE}/${incidentId}`),

  createIncident: (data, incidentId) =>
    incidentId
      ? KoAPI.put(`${INCIDENTS_BASE}/${incidentId}`, data)
      : KoAPI.post(INCIDENTS_BASE, data),

  deleteIncident: (incidentId) =>
    KoAPI.delete(`${INCIDENTS_BASE}/${incidentId}`),

  addIncidentNote: (incidentId, data) =>
    KoAPI.post(`${INCIDENTS_BASE}/${incidentId}/notes`, data),

  resolveIncident: (incidentId, data) =>
    KoAPI.post(`${INCIDENTS_BASE}/${incidentId}/resolve`, data),

  getIncidentTimeline: (incidentId) =>
    KoAPI.get(`${INCIDENTS_BASE}/${incidentId}/timeline`),

  // ── Dashboard Aggregates ──────────────────────────────────────
  getMonitoringDashboard: (params) =>
    KoAPI.get(`${BASE}/dashboard`, { params }),

  // ── Service List (for dropdowns) ──────────────────────────────
  getServiceList: (params) =>
    KoAPI.get(`${BASE}/services/list`, { params }),

  // ── Release List (for dropdowns) ──────────────────────────────
  getReleaseList: (params) =>
    KoAPI.get('/v1/releases', { params })
};
